<medrecord-auth-twofa-verification
  [title]="'tfa_stwo_six_digit_number'"
  [lostStuffDescription]="'tfa_stwo_no_access_auth_app'"
  (clickHere)="redirectToRecovery()"
></medrecord-auth-twofa-verification>